<template>
  <div class="divLogin" align-v="center">
    <h3>Cargando...</h3>
  </div>
</template>

<script>

export default {
  data() {
    return {
      login: {
        name: "",
        password: "",
        info: "",
        messageError: ""
      },
      activeColor: 'red',
      fontSize: 20
    };
  },
  // methods: {
  //   //Metodo que autentica contra la API Services y almacena los datos de la sesión
  //   loginUser(token) {
  //     this.axios.get(process.env.VUE_APP_URL_API+"/Authenticate/Login", {
  //         params: {
  //           token: token
  //         }
  //       })
  //       .then(response => {
  //         if (response != null) 
  //         {
  //           this.$session.start();
  //           //se almacena los datos de la sesion
  //           this.$session.set('login-storage', token)
  //           this.$router.push({ name: "resumen" });
  //         } else {
  //           this.login.messageError =
  //             "Los datos de usuario y/o contraseña son incorrectos";
  //         }
  //       });
  //   }
  // },
  created(){
    const self = this;

    if(typeof self.$route.query.token === 'undefined' || self.$route.query.token == 'undefined' || self.$route.query.token == '')
    {
        window.location = process.env.VUE_APP_URL_SUITE;
    }

    this.axios.get(process.env.VUE_APP_URL_API+"/Authenticate/Login", {
        params: {
          token: self.$route.query.token
        }
      })
      .then(response => {

        if (response.data != null && response.data != "") 
        {
          this.$session.start();
          //se almacena los datos de la sesion
          this.$session.set('login-storage', response.data)
          this.$router.push({ name: "resumen" });
        } else {
          window.location = process.env.VUE_APP_URL_SUITE;
        }
      });
  }

};
</script>

<style>
.divLogin {
  width: 100%;
  display: block;
  justify-content: center;
  align-items: center;
}
.divLoginHijo {
  width: 35%;
  margin: 0 auto;
  margin-top: 20px;
}
</style>

